export const isIOS = () => {
  if (typeof navigator === 'undefined') return false

  const ua = navigator.userAgent

  const iOS = /iPad|iPhone|iPod/.test(ua)

  // iPadOS 13+ reports as Mac
  const iPadOS = navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1

  return iOS || iPadOS
}
